import AppSearchPageMixin from "@/protected/mixins/AppSearchPageMixin";
import pluralize from "pluralize";

import BaseRequestCreateParametersEditor from "./BaseRequestCreateParametersEditor";

export default {
  mixins: [AppSearchPageMixin],

  methods: {
    /*
    initParameters() {
      return {
        statusId:
          this.$route.query && this.$route.query.statusId
            ? [this.$route.query.statusId]
            : undefined
      };
    },
    */

    evaluationPage() {
      // 'CreditAssignmentRequests' -> 'CreditAssignmentEvaluation'
      const routeName = this.$route.name;
      return routeName.replace("Requests", "Evaluation");
    },

    requestPage() {
      // 'CreditAssignmentRequests' -> 'CreditAssignmentRequest'
      const routeName = this.$route.name;
      return pluralize.singular(routeName);
    },

    async create({ customer, network, handleError, hideModal } = {}) {
      let id;
      try {
        const { data } = await this.getService().create({
          customerId: customer && customer.id,
          networkId: network && network.id
        });
        id = data.id;
        hideModal && hideModal();
      } catch (e) {
        await handleError(e);
        return;
      }

      this.$router.push({
        name: this.requestPage(),
        params: { id },
        query: { edit: true }
      });
    },

    async onAdd() {
      if (this.loggedUser.type === "CUSTOMER") {
        await this.create({
          handleError: async e => await this.handleError(e)
        });
      } else {
        let dynaModal;
        let value = {};
        let errors = null;

        const props = {
          value,
          errors
        };

        const events = {
          cancel: () => {
            console.log("CANCEL");
          },

          hidden: () => {
            console.log("HIDDEN");
            dynaModal.$destroy();
          },

          input: newValue => {
            console.log("INPUT", newValue);
            value = newValue;
            dynaModal.value = newValue;
          },

          ok: async evt => {
            evt.preventDefault();
            errors = null;
            dynaModal.errors = errors;
            await this.create({
              ...value,
              handleError: async e => {
                if (e.statusCode === 422) {
                  errors = e.data;
                  dynaModal.errors = errors;
                } else {
                  await this.handleError(e);
                  dynaModal.hide();
                }
              },
              hideModal: () => dynaModal.hide()
            });
          }
        };

        dynaModal = this.addComponent(BaseRequestCreateParametersEditor, {
          props,
          events
        });

        dynaModal.show();
      }

      console.log("this", this);
    },

    variantFor(s) {
      const type = typeof s === "string" ? s : s.type;

      switch (type) {
        case "INITIAL":
          return "info";
        //case 'INTERMEDIATE':
        //  return 'warning';
        //case 'SUCCESS':
        case "SENT":
          return "success";
        //case 'FAILURE':
        //  return 'danger'
      }
      throw Error("Unsupported type: " + type);
    }
  }
};
